import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { ContentObjectListDataObject } from 'models/service';

type FeedRequest = {
  community_id?: string;
  pinned?: boolean;
} & CursorPaginationRailsParams;

export const getFeed = async ({ config }: ConfigRequest<FeedRequest>) =>
  apiClient.get<ContentObjectListDataObject[], ApiClientResponse<ContentObjectListDataObject[]>>(
    routes.contentObjects.feed,
    config,
  );
